import { Fields } from "~/constants/forms";
import { GROUP_NAME } from "~/constants/strings";

export const columns = [
  {
    Header: GROUP_NAME,
    accessor: Fields.GROUP_NAME,
  },
];
